import { AfterViewInit, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout/layout.service';
import { HeaderType } from 'src/app/types/route';
import { HeaderLandingComponent } from './landing/landing.component';

@Component({
  templateUrl: './header.component.html',
  standalone: true,
  selector: 'app-header',
  imports: [HeaderLandingComponent],
})
export class HeaderComponent implements AfterViewInit {
  private _height = 0;

  HeaderType = HeaderType;
  isCollapsed = false;

  layoutService = inject(LayoutService);
  router = inject(Router);

  get headerType() {
    return this.layoutService.headerType;
  }

  ngAfterViewInit(): void {
    const headerEle = document.querySelector('#header');

    if (!headerEle) this._height = 80;
    else this._height = headerEle.getBoundingClientRect().height;
  }

  get height() {
    return this.headerType === HeaderType.Landing ? this._height : 0;
  }

  get showHeader() {
    return this.layoutService.showHeader;
  }
}
